


















import Vue from "vue";
import { VUEX_EXERCISE_ACTION_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

import BaseExerciseFooter from "@tt-app/components/exercise/consolidated/exercise/footer/BaseExerciseFooter.vue";

import IconCheck from "@joyz/app-core/assets/icons/white/Check.svg";
import IconCheckbox from "@joyz/app-core/assets/icons/default/Checkbox.svg";

const { INCREMENT_PAGE } = VUEX_EXERCISE_ACTION_NAMES;

interface Data {
  icons: { [key: string]: string };
}

interface Computed {
  practiceButtonStatus: { disabled: boolean; icon: string };
}

interface Props {
  disabled: boolean;
  selectedUuids: string[];
}

export default Vue.extend<Data, any, Computed, Props>({
  name: "ExerciseScopeButtons",

  components: {
    BaseExerciseFooter
  },

  props: {
    disabled: { type: Boolean, default: false },
    selectedUuids: { type: Array, default: () => [] }
  },

  data() {
    return {
      icons: {
        check: IconCheck,
        checkbox: IconCheckbox
      }
    };
  },

  methods: {
    startTest() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${INCREMENT_PAGE}`);
    },

    startPractice() {
      console.log("start practice");
    }
  },

  computed: {
    practiceButtonStatus() {
      const disabled = this.selectedUuids.length <= 0;

      const icon = disabled ? this.icons.checkbox : this.icons.check;

      return {
        disabled,
        icon
      };
    }
  }
});
